module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-200.woff2?4e9592cdcbbbf7a0c610c754cb389fe1";